import { Injectable, signal } from '@angular/core';
import { ApiService, MenuCategory } from './api.service';

@Injectable({ providedIn: 'root' })
export class MenuService {

  menuData = signal<MenuCategory[]>([]);
  private loaded = false;

  constructor(private apiService: ApiService) {}

  load(): void {
    if (this.loaded) return;
    this.loaded = true;

    this.apiService.getMenu().subscribe({
      next: res => { this.menuData.set(res.data); }
    });
  }
}
